<template>
    <el-dialog :title="title" :visible.sync="show" width="500px">
        <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="80">
            <el-form-item label="大区名称" prop="name">
                <el-input v-model="ruleForm.name" :autofocus="true" placeholder="大区名称" :maxlength="30" width="300px"></el-input>
            </el-form-item>
        </el-form>
        <!-- </div> -->
        <span slot="footer" class="dialog-footer" style="text-align:center;">
            <el-button @click="show = false">取 消</el-button>
            <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
import { isNumber_AZ_Chinese } from "@/plugins/common";
import apis from "@/config/apis";
export default {
    data() {
        var validateHard_number = (rule, value, callback) => {
            if (!isNumber_AZ_Chinese(value)) {
                return callback(new Error("请输入中文、字母或者数字，最大30个字符"));
            } else {
                return callback();
            }
        };
        return {
            show:false,
            title: '',
            ruleForm: {
                name: "",
                id: ""
            },
            rules: {
                name: [{
                    required: true,
                    validator: validateHard_number,
                    trigger: "change"
                }]
            }
        };
    },
    props: {
    },
    methods: {
        modifyshow(row) {
            this.show = true;
            this.title = row.title;
            this.ruleForm.name = row.name;
            this.ruleForm.id = row.id;
        },
        addshow(row) {
            this.show = true;
            this.ruleForm.name = "";
            this.ruleForm.id = '';
            this.title = row.title;
        },
        close() {
            this.$refs.ruleForm.resetFields();
            this.modalShow = false;
            this.ruleForm.name = "";
        },
        confirm(ruleForm) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.ruleForm.id) {
                        let jsonData = {
                            id: this.ruleForm.id,
                            name: this.ruleForm.name
                        };
                        this.$axios.put(apis.updateregion, jsonData).then(res => {
                            if (res.data.code === 200) {
                                this.$emit("emitConfirm");
                                this.$message({
                                  message: '修改成功',
                                  type: 'success'
                                 });
                                this.show = false;
                                this.$refs.ruleForm.resetFields();
                            } else {
                                this.show = true;
                                this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                            }
                        });
                    } else {
                        let jsonData = {
                            name: this.ruleForm.name
                        }
                        this.$axios.post(apis.addregion, jsonData).then(res => {
                            if (res.data.code === 200) {
                                this.$emit("emitConfirm")
                                this.show = false;
                                this.$message({
                                  message: '新增成功',
                                  type: 'success'
                                 });
                                this.$refs.ruleForm.resetFields();
                            } else {
                              this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                            }
                        })
                    }
                }
            });
        }
    },
    watch: {}
};
</script>


<style lang="scss" scoped>
.el-dialog__footer{
  text-align: center;
}
.el-input{
    width:250px;
}
</style>